// Height ÷ width for every format the CMS can send. Kept as numbers so one value
// can drive both the container's `aspect-ratio` and the lightbox's fitting math.
const RATIOS: Record<string, number> = {
  '1:1': 1,
  '4-3': 0.75,
  '16-9': 0.5625,
  '21-9': 0.4285,
  '3-4': 1.3333,
  '9-16': 1.7778,
  '9-21': 2.3333,
}

const DEFAULT_RATIO = 0.5065

export const SLIDESHOW_RATIO = '16-9'

export type VideoRatio = string | number | undefined | null

export const videoRatioValue = (ratio: VideoRatio): number => {
  if (typeof ratio === 'number') {
    return ratio > 0 ? ratio : DEFAULT_RATIO
  }
  return (ratio && RATIOS[ratio]) || DEFAULT_RATIO
}

export const isReelUrl = (url?: string) => {
  if (!url) {
    return false
  }
  return url.includes('/shorts/');
}

export const resolveVideoRatio = (
  url?: string,
  style?: { videoRatios?: string },
  detectedRatio?: number | null,
  pinnedRatio?: VideoRatio,
): VideoRatio => {
  if (pinnedRatio) {
    return (style && style.videoRatios) || pinnedRatio
  }
  if (detectedRatio && detectedRatio > 0) {
    return detectedRatio
  }
  return isReelUrl(url) ? '9-16' : style && style.videoRatios
}
